const TrackingCodes = Object.freeze({
    // VC Analytics event names
    eventTypes: {
        vcSteps: 'vcSteps',
        vcClick: 'vcClick',
        socialShare: 'socialShare',
        genericClick: 'genericClick',
        carouselInteraction: 'carouselInteraction',
    },
    // VC Analytics tracking variables
    trackingVars: {
        vcSteps: {
            componentId: 'componentId',
            toolName: 'toolName',
            vcStep: 'vcStep',
        },
        vcClick: {
            componentId: 'componentId',
            toolName: 'toolName',
            vcStep: 'vcStep',
            vcClick: 'vcClick',
        },
        socialShare: {
            componentId: 'componentId',
            urlShared: 'urlShared',
            contentInteraction: 'contentInteraction',
            contentAction: 'contentAction',
            socialNetwork: 'socialNetwork',
        },
        genericClick: {
            componentId: 'componentId',
            destination: 'destination',
            locationInPage: 'locationInPage',
            buttonText: 'buttonText',
        },
        carouselInteraction: {
            componentId: 'componentId',
            carouselType: 'carouselType',
            interactionType: 'interactionType',
            itemNumber: 'itemNumber',
            promoText: 'promoText',
        },
    },
    persistentProperties: [
        'adobeAccount',
        'googleAccount',
        'targetCode',
        'pageName',
        'pageType',
        'loginStatus',
        'vehicleModel',
        'vehicleId',
        'vehicleCategory',
        'countryCode',
        'languageCode',
        'mboxActivated',
    ],
    // VC Analytics tracking constant values
    trackingValues: {
        componentIds: {
            virtual_car: 'c314_virtual_car',
        },
        scenes: {
            splash: 'introduction',
            exterior: 'home',
            awaken: 'design',
            engine: 'powerfully',
            propilot: 'driverAssist',
            menuOverlay: 'menu:overlay',
            registerInterest: 'register interest',
            trip: 'connectivity:app',
            voiceassistant: 'connectivity:home',
            inside: 'connectivity:in car',
        },
        design: {
            awaken: 'awaken',
            hotspots: 'hotspots',
        },
        connectivity: {
            navigate: 'navigation',
            music: 'playlist',
            home: 'home',
            message: 'messages',
        },
        performance: {
            traffic: 'stop and go traffic',
            activateRain: 'activate rain',
        },
        driverAssist: {
            activateProPilot2: 'activate pro-pilot 2.0',
            parkTheCar: 'park the car',
            activateProPilotPark: 'activate pro-pilot park',
            getIntoTheCar: 'get into the car',
            moveTheCar: 'move the car',
            proceed: 'proceed',
        },
        socialShare: {
            contentAction: 'intention',
        },
        routes: {
            menuNavigation: 'menu:navigation',
            menuOverlay: 'menu:overlay',
        },
        locationInPage: {
            registerInterest: 'virtual car:register interest',
        },
        toolName: 'virtual car',
        hotspotPrefix: 'hotspot:',
        slidePrefix: 'slide:',
        scrollPrefix: 'scroll:',
    },
});

export default TrackingCodes;
